// extracted by mini-css-extract-plugin
module.exports = {"disabled":"permit-component_disabled__3zMGm"};